import { trackEvent } from '../../analytics/analyticsTracker';

export function trackSkipLogicTriggered(metadata: {
  questionId: string;
  skipLogicId: string;
  targetType: 'QUESTION' | 'END_OF_SURVEY';
  targetId: string;
  fromPageIndex: number;
}): void {
  trackEvent({ eventName: 'skip_logic_triggered', metadata });
}

export function trackPageSkipped(metadata: {
  fromPageIndex: number;
  toPageIndex: number;
  reason: 'skip_logic' | 'empty_page';
}): void {
  trackEvent({ eventName: 'page_skipped', metadata });
}

export function trackSurveyStarted(metadata: { source: 'intro' | 'auto' }): void {
  trackEvent({ eventName: 'survey_started', metadata });
}

export function trackPhaseTransition(metadata: { from: string; to: string }): void {
  trackEvent({ eventName: 'phase_transition', metadata });
}
